import Vue, { VNode } from 'vue'

export default Vue.extend({
  props: {
    tag: {
      required: true,
      type: String,
    },
  },
  render(): VNode {
    const Tag = this.tag
    return (
      <Tag {...this.$attrs}>
        { this.$slots.default ? this.$slots.default : '' }
      </Tag>
    )
  },
})
